import { utils, config } from "../../../../studentportal-sdk";

// create a workspace project
export const createProject = async ({
  title,
  shortDescription,
  fullDescription,
  category,
  startDate,
  endDate,
  priority
}) => {
  try {
    const { data} = await utils
      .apiConnect()
      .post(config.domains.endpoints.postCreateProjectApi, {
        title,
        shortDescription,
        fullDescription,
        category,
        startDate,
        endDate,
        priority
      });
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

// update a workspace project
export const updateProject = async ({
  projectId,
  title,
  shortDescription,
  fullDescription,
  category,
  startDate,
  endDate,
  priority
}) => {
  try {
    const { data} = await utils
      .apiConnect()
      .put(config.domains.endpoints.putUpdateProjectApi, {
        projectId,
        title,
        shortDescription,
        fullDescription,
        category,
        startDate,
        endDate,
        priority
      });
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

// filter workspace project
export const filterProject = async ({
  q,
  createdBy,
}) => {
  try {

    let queryParams = '';
    q && (queryParams = `${queryParams}q=${q}&`);
    createdBy && (queryParams = `${queryParams}createdBy=${createdBy}&`);
    queryParams = `${queryParams}page=1&pageSize=50`

    const { data} = await utils
      .apiConnect()
      .get(`${config.domains.endpoints.getProjectFilterApi}?${queryParams}`,);
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

// delete a project
export const deleteProject = async ({
  projectId
}) => {
  try {
    const { data} = await utils
      .apiConnect()
      .post(config.domains.endpoints.deleteProjectApi,{
        projectId
      });
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};


